import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Hook to manage Crisp chat visibility based on current route
export const useCrispVisibility = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we're on a booking page
    const isBookingPage = 
      location.pathname.startsWith('/book/') ||
      location.pathname.startsWith('/booking/');

    // Check if we're on the onboarding page
    const isOnboardingPage = location.pathname === '/onboarding';

    const hideCrisp = () => {
      if (typeof window !== 'undefined' && window.$crisp) {
        try {
          window.$crisp.push(['do', 'chat:hide']);
          // Also try to hide the launcher specifically
          window.$crisp.push(['do', 'launcher:hide']);
        } catch (error) {
          console.error('Error hiding Crisp:', error);
        }
      }
    };

    const showCrisp = () => {
      if (typeof window !== 'undefined' && window.$crisp) {
        try {
          window.$crisp.push(['do', 'chat:show']);
          window.$crisp.push(['do', 'launcher:show']);
        } catch (error) {
          console.error('Error showing Crisp:', error);
        }
      }
    };

    // Function to manage Crisp visibility
    const manageCrispVisibility = () => {
      if (isBookingPage || isOnboardingPage) {
        hideCrisp();
      } else {
        showCrisp();
      }
    };

    // Try immediately
    manageCrispVisibility();

    // If Crisp isn't loaded yet, poll for it
    if (typeof window !== 'undefined' && !window.$crisp) {
      const interval = setInterval(() => {
        if (window.$crisp) {
          manageCrispVisibility();
          clearInterval(interval);
        }
      }, 100);

      // Cleanup interval after 10 seconds
      setTimeout(() => clearInterval(interval), 10000);
    }

    // Also listen for Crisp ready event
    if (typeof window !== 'undefined') {
      const handleCrispReady = () => {
        manageCrispVisibility();
      };

      window.addEventListener('crisp:ready', handleCrispReady);
      
      return () => {
        window.removeEventListener('crisp:ready', handleCrispReady);
      };
    }
  }, [location.pathname]);
}; 